import { useMutation, useQueryClient } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';
import { useContext } from 'react';
import { LikeCommunityComment } from 'services/apiServices';
import {
  TLikeCommentResult,
  Errors,
} from 'types/ApiServicesTypes';

export default function useLikeCommunityComment() {
  const { showAlert } = useContext(ToastContext);
  const queryClient = useQueryClient();

  const mutation = useMutation<TLikeCommentResult, Errors, number>(
    ['LikeCommunityComment'],
    commentId =>
      LikeCommunityComment(commentId)
        .then(res => {
          // Invalidate and refetch comments
          void queryClient.invalidateQueries(['GetCommunityComments']);
          return res;
        })
        .catch(err => {
          showAlert!(err.message as string);
          return err;
        }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
} 